import {
  Step,
  StepConnector,
  StepIconProps,
  StepLabel,
  Stepper,
  withStyles,
} from '@material-ui/core';
// import BusinessRoutePath from 'app/business-app/BusinessRoutePath';
import IconBox from 'app/consumer-app/views/products/components/IconBox';
import { RepairAssignedProduct } from 'app/core/api/product-assignment/api-product-assignment.types';
import { MissingItemError } from 'app/core/errors/error-variants';
import ProductPictureOrDefault from 'app/shared/components/app-image/ProductPictureOrDefault';
import Button from 'app/shared/components/button/Button';
import Icon from 'app/shared/components/icon/Icon';
import IconLib, {
  DocumentSvg,
  SettingSvg,
  ExitSvg,
} from 'app/shared/components/icon/icon-lib';
import TileCardButton from 'app/shared/frames/TileCardButton';
import SharedRoutePath from 'app/shared/SharedRoutePath';
import styledFuncs from 'app/styles/styledFuncs';
import styledMixins from 'app/styles/styledMixins';
import { isEnumMember, PropsOf } from 'app/tools/general.types';
import { Markup } from 'interweave';
import React, { ReactNode, useEffect, useState } from 'react';
import { useResizeDetector } from 'react-resize-detector/build/withPolyfill';
import styled, { css } from 'styled-components/macro';
import { Except, Merge } from 'type-fest';

const NameBox = styled.div`
  position: relative;
  padding: ${styledFuncs.pad(0.5)};
  overflow: hidden;
  display: flex;
`;

const NameFadeOverlay = styled.div`
  position: absolute;
  bottom: -1px;
  width: 100%;
  height: 1.2em;
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0),
    rgba(255, 255, 255, 1) 90%
  );
`;

const ViewLink = styled.a`
  position: absolute;
  bottom: ${styledFuncs.pad(1.4)};
  right: ${styledFuncs.pad(2.1)};
`;

const DateSmallMarkup = styled(Markup)`
  font-size: 11px;
  font-weight: 400;
`;
const SmallMarkup = styled(Markup)`
  font-size: 12px;
  font-weight: 400;
`;
const MediumMarkup = styled(Markup)`
  font-size: 13px;
  font-weight: 500;
`;

const LargeMarkup = styled(Markup)`
  font-size: 13px;
  ont-weight: 600;
`;

const Name = styled.div`
  hyphens: auto;
  word-break: break-word;
  align-self: center;
  max-height: 100%;
`;

const PicOrDefault = styled(ProductPictureOrDefault)`
  padding: ${styledFuncs.pad(0.5)};
  height: 150px;
`;

const StyledIconBox = styled(IconBox)``;

const StyledStepper = styled(Stepper)`
  padding: 10px 10px 24px 0;
`;

const CardText = styled.div`
  font-weight: 600;
  font-size: 9px !important;
`;

const IconButtonText = styled(CardText)`
  margin-top: ${styledFuncs.pad()};
`;

// (don't ask)
export const getCardTextFontPx = ({
  $width,
}: CardButtonOpts): string => `${$width ** 0.3 * 3}px`;
export const getWideCardTextFontPx = ({
  $width,
}: CardButtonOpts): string =>
  getCardTextFontPx({ $width: $width * 0.7 });

const getAddBtnTextFontMax = ({ $width }: CardButtonOpts): number =>
  parseFloat(getWideCardTextFontPx({ $width: $width * 2 + 40 }));
const getAddBtnTextFontPx = ({ $width }: CardButtonOpts): string =>
  `${Math.min($width * 0.12, getAddBtnTextFontMax({ $width }))}px`;

type CardButtonOpts = {
  $variant?: 'wide' | 'wide-no-icons';
  $width: number;
};
const ProductListCardButton = styled(TileCardButton)<CardButtonOpts>`
  .MuiButton-endIcon {
    display: none;
  }
  .MuiButton-label > div {
    height: auto;
    flex-flow: row-reverse wrap;

    ${NameBox} {
      width: 45%;
    }
    ${PicOrDefault} {
      height: 60%;
      width: 45%;
    }
    ${StyledIconBox} {
      height: 40%;
      width: 100%;
    }
    ${CardText} {
      font-size: ${getCardTextFontPx};
      line-height: 1.4;
    }
    ${IconButtonText} {
      font-size: ${getAddBtnTextFontPx};
    }

    ${p =>
      p.wide &&
      css`
        flex-direction: row-reverse;

        ${NameBox} {
          width: 50%;
        }
        ${PicOrDefault} {
          height: 100%;
          width: 40%;
        }
        ${StyledIconBox} {
          margin: ${styledFuncs.pad(0.4)} 0;
          height: calc(55% - ${styledFuncs.pad(0.8)});
          width: 60%;
        }

        ${CardText} {
          font-size: ${getWideCardTextFontPx(p)};
          line-height: 1.4;
        }
      `}

    ${p =>
      p.wide &&
      p.$variant === 'wide-no-icons' &&
      css`
        ${NameBox} {
          height: 100%;
          width: 60%;
          padding-left: ${styledFuncs.pad()};
          padding-right: ${styledFuncs.pad()};
          ${styledMixins.flexCenter}
          align-items: flex-start;
          > div {
            max-height: 100%;
          }
        }
        ${PicOrDefault} {
          height: 100%;
          width: 40%;
          padding: ${styledFuncs.pad()};
        }
      `}
  }
`;

const IconTileButton = styled(ProductListCardButton)`
  .MuiButton-label > div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-weight: 600;
    > * {
      align-self: center;
    }
  }
`;

const ColorlibConnector = withStyles({
  alternativeLabel: {
    top: 15,
  },
  active: {
    '& $line': {
      backgroundColor: '#6ABC35',
    },
  },
  completed: {
    '& $line': {
      backgroundColor: '#6ABC35',
    },
  },
  line: {
    height: 3,
    border: 0,
    backgroundColor: '#EAEAEA',
    borderRadius: 1,
  },
})(StepConnector);
const ColorlibStepIconRoot = styled('div')<{
  ownerState: { completed?: boolean; active?: boolean };
}>(({ ownerState }) => ({
  backgroundColor: '#FFFFFF',
  zIndex: 1,
  color: '#000000',
  width: 35,
  height: 35,
  fontSize: 10,
  display: 'flex',
  borderRadius: '50%',
  justifyContent: 'center',
  alignItems: 'center',
  boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
  svg: {
    path: { fill: '#000000' },
  },
  ...(ownerState.active && {
    border: '1px solid #6ABC35',
    svg: {
      path: { fill: '#6ABC35' },
    },
  }),
  ...(ownerState.completed && {
    border: '1px solid #6ABC35',
    svg: {
      path: { fill: '#6ABC35' },
    },
  }),
}));
type Props = Merge<
  Except<PropsOf<typeof Button>, 'ref'>,
  {
    variant?: 'wide' | 'wide-no-icons';
    item?: RepairAssignedProduct;
    iconButtonIcon?: IconLib | ReactNode;
    iconButtonText?: string;
    iconButtonColor?: string;
    displayType?: 'withTracking' | 'withoutTracking';
  }
>;
export default function ProductCard({
  item,
  variant,
  iconButtonIcon,
  iconButtonText,
  iconButtonColor,
  displayType,
  ...buttonProps
}: Props): JSX.Element {
  const { width = 300, ref } = useResizeDetector();

  const wide = variant === 'wide' || variant === 'wide-no-icons';
  const steps = ['Customer Drop Off', 'Under Repair', 'Pick Up'];
  const [activeStep, setActiveStep] = useState<number>(0);
  useEffect(() => {
    const step =
      item?.currentStatus === 'repair_complete'
        ? 2
        : item?.currentStatus === 'under_repair'
        ? 1
        : 0;
    setActiveStep(step);
  }, [item]);
  function ColorlibStepIcon(props: StepIconProps) {
    const { active, completed, className } = props;

    const icons: { [index: string]: React.ReactElement } = {
      1: <DocumentSvg />,
      2: <SettingSvg />,
      3: <ExitSvg />,
    };
    const { icon } = props;
    return (
      <ColorlibStepIconRoot
        ownerState={{ completed, active }}
        className={className}
      >
        {icons[String(icon)]}
      </ColorlibStepIconRoot>
    );
  }
  if (item && !iconButtonIcon) {
    const clickDestination = `${SharedRoutePath.CHAT}/${item.id}`;

    const picWidth = wide ? 0.4 * width : 0.45 * width;

    return (
      <ProductListCardButton
        $variant={variant}
        $width={width}
        to={clickDestination}
        {...{ ref, wide }}
        {...buttonProps}
      >
        <div
          style={{
            minHeight: '160px',
            display: 'flex',
            height: 'auto',
            flexFlow: 'row-reverse wrap',
            flexDirection: 'row-reverse',
            width: '100%',
          }}
        >
          <div
            style={{
              width: '60%',
              height: '150px',
              display: 'flex',
              justifyContent: 'center',
              alignContent: 'center',
              flexDirection: 'column',
            }}
          >
            <NameBox style={{ textAlign: 'left', width: '100%' }}>
              <Name>
                <CardText>
                  <LargeMarkup
                    content={
                      item.productName.length > 50
                        ? `${item.productName.substring(0, 50)}...`
                        : item.productName
                    }
                  />
                </CardText>
              </Name>
            </NameBox>
            <NameBox style={{ width: '100%', textAlign: 'left' }}>
              <Name>
                <CardText>
                  <MediumMarkup content={item.customerName} />
                </CardText>
              </Name>
            </NameBox>
            {displayType === 'withoutTracking' && (
              <>
                <div style={{ width: '100%' }}>
                  <NameBox
                    style={{
                      width: '60%',
                      float: 'left',
                      textAlign: 'left',
                    }}
                  >
                    <Name>
                      <CardText>
                        <SmallMarkup content={item.issueType} />
                      </CardText>
                    </Name>
                  </NameBox>
                  <NameBox
                    style={{
                      textAlign: 'right',
                      width: '40%',
                      float: 'right',
                    }}
                  >
                    <Name>
                      <CardText>
                        <DateSmallMarkup content={item.date} />
                      </CardText>
                    </Name>
                    <NameFadeOverlay />
                  </NameBox>
                </div>
                <div>
                  <ViewLink
                    href={clickDestination}
                    style={{
                      fontSize: '9px',
                      fontWeight: 600,
                    }}
                  >
                    View more details
                  </ViewLink>
                </div>
              </>
            )}
            {variant === 'wide' && displayType === 'withTracking' && (
              <StyledStepper
                alternativeLabel
                activeStep={activeStep}
                connector={<ColorlibConnector />}
              >
                {steps.map(label => (
                  <Step key={label}>
                    <StepLabel
                      StepIconComponent={(e: StepIconProps) =>
                        ColorlibStepIcon(e)
                      }
                    >
                      <span style={{ fontSize: '10px' }}>
                        {label}
                      </span>
                    </StepLabel>
                  </Step>
                ))}
              </StyledStepper>
            )}
          </div>
          <PicOrDefault
            productId={item.id}
            src={item.imageUrl}
            alt={`${item.productName ?? ''}`}
            sideSizeForCornerRadius={`${picWidth}px`}
            style={{ maxHeight: '120px', margin: 'auto' }}
          />
          {/* {isAsgnProduct(item) && (
          <StyledIconBo
            assignedProduct={item}
            wide={variant === 'wide'}
          />
        )} */}
        </div>
      </ProductListCardButton>
    );
  } else if (iconButtonIcon) {
    return (
      <IconTileButton
        color="primary"
        variant="contained"
        $width={width}
        css={css`
          ${iconButtonColor &&
          styledMixins.buttonColor(iconButtonColor)}
        `}
        aria-label={iconButtonText?.toLowerCase()}
        {...buttonProps}
        {...{ ref, wide }}
      >
        {isEnumMember(iconButtonIcon, IconLib) ? (
          <Icon
            icon={iconButtonIcon}
            size={Math.min(width * 0.5, 100)}
          />
        ) : (
          <Icon
            imgNode={iconButtonIcon}
            size={Math.min(width * 0.5, 100)}
          />
        )}

        <IconButtonText>{iconButtonText}</IconButtonText>
      </IconTileButton>
    );
  } else {
    throw new MissingItemError('product item');
  }
}
